/**
 * Display a list of course cards in the added to planner UI container
 * @param {} $scope 
 * @param {} timetableService 
 * @param {} storageService 
 * @returns {} 
 */
export default function ($scope, timetableService, storageService) {

    /**
     * Update the added to planner list when selected term updates
     */
    timetableService.subscribe($scope, 'selectedTermChanged', () => {
        $scope.vm.addedToPlanner = storageService.getPlanner();
    });

    /**
     * Receive model updates when the recent courses object is updated in the service
     */
    timetableService.subscribe($scope, 'plannerChanged', (e, args) => {
        $scope.vm.addedToPlanner = args.addedToPlanner;
    });
};